import { PromptType } from "../Wazawan";
import "./WazawanOverview.css";

export type OverviewItem = {
    id: string;
    type: PromptType;
    topPercentage: number;
    bottomPercentage: number;
}

const OVERVIEW_COLORS = {
    "reporting": "#FFD700",
    "asset": "#FF4500",
    "ui": "#0000FF",
    "form-fill": "#FF00FF",
    "open": "#00FF00",
    "general": "#FF0000",
}

type WazawanOverviewProps = {
    overviewItems: Map<string, OverviewItem> | null;
    onClick: (id: string) => void;
}

export const WazawanOverview = ({overviewItems, onClick} : WazawanOverviewProps) => {
    console.log("[WazawanOverview] overviewItems: ", overviewItems);

    return (
        <>
            {overviewItems &&
                <div className="wazawan-overview">
                    {overviewItems && Array.from(overviewItems.keys()).map(key => {
                        const overviewItem = overviewItems.get(key);

                        if (!overviewItem) {
                            return null;
                        }

                        const color = OVERVIEW_COLORS[overviewItem.type as keyof typeof OVERVIEW_COLORS] || "gray";
                        const topPercentage = overviewItem.topPercentage || 0;
                        const bottomPercentage = overviewItem.bottomPercentage || 0;

                        console.log("[WazawanOverview] key: ", key);
                        console.log("[WazawanOverview] overviewItem: ", overviewItem);
                        console.log("[WazawanOverview] color: ", color);
                        
                        return (
                            <>
                                <div 
                                    className="wazawan-overview-item"
                                    style={{
                                        backgroundColor: color,
                                        top: `${topPercentage}%`,
                                        height: `${bottomPercentage-topPercentage}%`
                                    }}
                                    onClick={()=> onClick(key)}
                                >
                                    { }
                                </div>
                            </>
                        )
                        })
                    }
                </div>
            }
        </>
    )
}

